<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        司机信息
        <template slot="operate">
          <el-button
            v-if="operationSuper.删除"
            class="g-form-section-search operate__item"
            title="删除"
            icon="e6-icon-clear_line"
            @click="deleteBatchDriverInfo"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导入"
            v-if="operationSuper.导入"
            icon="e6-icon-Import_fill"
            @click="openImport"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.编辑"
            class="g-form-section-search operate__item"
            title="编辑"
            icon="el-icon-plus"
            plain
            @click="handleDriverInfoEidtDialog('add')"
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.driverName">
            <el-input
              v-model="slotForms.forms.driverName"
              placeholder="司机姓名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.corpName">
            <el-input
              v-model="slotForms.forms.corpName"
              placeholder="所属企业"
              clearable
            ></el-input>
            <!-- <el-select
              v-model="slotForms.forms.corpName"
              placeholder="所属企业"
              clearable
            >
              <el-option
                v-for="item in corpOptions"
                :key="item.moduleId"
                :label="item.moduleName"
                :value="item.moduleId"
              ></el-option>
            </el-select> -->
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <!-- 多选 -->
        <el-table-column
          align="center"
          type="selection"
          width="55"
          :selectable="checkboxInit"
        ></el-table-column>
        <!-- 序号 -->
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <!-- 其他表格列 -->
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          :prop="item.name"
          :label="item.title"
          :formatter="tableFromatter"
        ></el-table-column>
        <!-- 操作列 -->
        <el-table-column fixed="right" align="center" label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button
              v-if="
                operationSuper.编辑 && row.isEditable === 1 && checkboxInit(row)
              "
              type="text"
              size="small"
              @click="handleDriverInfoEidtDialog('edit', row)"
              >编辑</el-button
            >&nbsp;
            <el-button
              v-if="
                operationSuper.删除 && row.isEditable === 1 && checkboxInit(row)
              "
              type="text"
              size="small"
              @click="deleteDriverInfo(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->

    <!-- 新增/编辑司机信息弹框 -->
    <el-dialog
      ref="driverInfoEdit"
      :title="driverInfoEditDialogName"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="driverInfoEditVisible"
      @closed="handleCloseEditDialog"
      width="350px"
    >
      <div>
        <el-form
          label-position="right"
          label-width="100px"
          :rules="rules"
          :model="editForm"
          ref="editForm"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item
                prop="corpId"
                label="所属企业"
                :rules="[
                  {
                    required: true,
                    message: '请选择所属企业',
                    trigger: 'change'
                  }
                ]"
              >
                <el-select
                  v-model="editForm.corpId"
                  collapse-tags
                  filterable
                  placeholder="所属企业"
                >
                  <el-option
                    v-for="item in allCustomer"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="姓名" prop="driverName">
                <el-input
                  v-model="editForm.driverName"
                  clearable
                  placeholder="请输入司机姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="电话" prop="phone">
                <el-input
                  v-model="editForm.phone"
                  clearable
                  placeholder="请输入司机司机电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="性别" prop="sex">
                <el-radio-group v-model="editForm.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="身份证号" prop="idCard">
                <el-input
                  v-model="editForm.idCard"
                  clearable
                  placeholder="请输入身份证号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="驾驶证类型" prop="licenseLevel">
                <dict-select
                  v-model="editForm.licenseLevel"
                  placeholder="车辆类型"
                  :pkey="'driver_license_type'"
                ></dict-select>
                <!-- <el-select
                  v-model="editForm.licenseLevel"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="item in licenseLevelOption"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="绑定车辆" prop="vehicle">
                <e6Select
                  :dataList="vehicleTreeList"
                  :filterable="true"
                  :slotTemplate="'tree'"
                  :multiple="false"
                  :issingleleaf="false"
                  ref="t_select"
                  :placeholder="'请选择'"
                ></e6Select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">取 消</el-button>
        <el-button
          type="primary"
          @click="submitEditDialog"
          :loading="saveDialog"
          >保 存</el-button
        >
      </span>
    </el-dialog>

    <!--导入弹框-->
    <upload-center
      ref="addGoodsFile"
      :visible.sync="dialogImportVisible"
      :initInfo="importParams"
      @update:visible="updateSuccess"
    ></upload-center>
  </div>
</template>
<script>
const newEditForm = {
  driverName: "", // 司机姓名
  phone: "", //司机电话
  sex: "", //司机性别 2:女 1:男
  idCard: "", // 身份证号
  licenseLevel: "", //驾驶证类型
  corpId: ""
  // vehicleNo: "", //绑定车辆
  // vehicleId: 0
};
import {
  FetchGetTableColumnSettings
  //FetchSaveUserTableColumnSettings,
  //FetchGetAllModule
} from "_private/api/public.js";
import {
  FetchFindByPage,
  saveEditDriver,
  deleteDriver,
  FetchVehicleOptionList
} from "@/api/base/driver";
import operationManage from "_private/mixins/operationManage";
import listInit from "@/mixins/listInit";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import { CheckPhone, validatorIdCard } from "@/utils/validation.js";
import { cloneDeep } from "lodash";
import e6Select from "e6select";
import uploadCenter from "@/components/uploadCenter";
import { FetchAllCustomer } from "@/api/systemSetting/interfaceUserManager";
export default {
  components: { e6Select, uploadCenter },
  mixins: [operationManage, listInit, resizeListener],
  data() {
    return {
      tableLoading: false,
      // 查询
      formExtend: {
        forms: {
          driverName: "", //司机姓名
          corpName: "" //所属企业Id
        },
        extends: []
      },
      isSearch: false,
      //所属企业下拉框数据
      // corpOptions: [],
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      allCustomer: [],
      localShowTableCols: [], //表格列
      tableData: [], //表格数据
      multipleSelection: [], //表格多选
      total: 0,

      curPage: 1,
      pageSize: 20,

      driverInfoEditVisible: false,
      driverInfoEditDialogName: "", //新增/编辑司机信息弹框标题

      //司机信息编辑表单
      editForm: newEditForm,
      //驾驶证类型下拉选择
      licenseLevelOption: [],
      //车牌号下拉框
      vehicleTreeList: [],
      // 编辑司机信息表单校验
      rules: {
        driverName: [
          { required: true, message: "请输入司机姓名", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: CheckPhone, trigger: "blur", required: true }
        ],
        idCard: [{ validator: validatorIdCard, trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }]
      },

      //导出URL
      exportUrl: "/driverInfo/exportDriverInfo?",
      // 导入相关
      dialogImportVisible: false,
      importParams: {
        title: "导入司机信息",
        templateUrl: "/static/司机信息导入模板.xls",
        importUrl: "/driverInfo/importDriverInfo"
      },
      //表格列设置
      columSetVisible: false,
      //保存dialog时，按钮加上loading
      saveDialog: false
    };
  },

  created() {
    this.initVehicleTree();
    this.initAllCustomer();
    this.init();
    // console.log(this.$store);
  },
  mounted() {},
  methods: {
    checkboxInit(row) {
      return row.isEditable === 1 ? 1 : 0;
    },
    //初始化数据
    async init() {
      try {
        this.tableLoading = true;
        //请求表格列数据和表格数据
        let [columnRes, tableRes] = await Promise.all([
          FetchGetTableColumnSettings({
            userId: this.userId,
            moduleId: this.moduleId
          }),
          FetchFindByPage(this.mergeObj())
        ]);
        this.setTableColumnData(columnRes);
        this.setTableData(tableRes);
      } catch (error) {
        console.log(error);
      } finally {
        this.tableLoading = false;
      }
    },
    //初始化区位树
    initVehicleTree() {
      FetchVehicleOptionList()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    /**
     *  初始化企业下拉信息
     */
    initAllCustomer() {
      FetchAllCustomer()
        .then(response => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allCustomer = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //请求表格内容
    async getTableData() {
      try {
        this.tableLoading = true;
        //请求表格列数据和表格数据
        let tableRes = await FetchFindByPage(this.mergeObj());
        this.setTableData(tableRes);
      } catch (error) {
        console.log(error);
      } finally {
        this.tableLoading = false;
      }
    },
    // 设置表格列数据
    setTableColumnData(response) {
      let showTableCols = [];
      let hideTableCols = [];
      if (response.result && Array.isArray(response.result)) {
        response.result.forEach(item => {
          if (item.show) {
            showTableCols.push(item);
          } else {
            hideTableCols.push(item);
          }
        });
      }
      this.showTableCols = showTableCols;
      this.hideTableCols = hideTableCols;
      this.copyShowTableCols = showTableCols;
      this.copyHideTableCols = hideTableCols;
      this.localShowTableCols = showTableCols;
    },
    // 设置表格数据
    setTableData(response) {
      if (
        response.result &&
        response.result.data &&
        Array.isArray(response.result.data)
      ) {
        this.tableData = response.result.data;
        this.total = response.result.totalRecords;
      }
    },
    //表格部分数据格式化
    tableFromatter(row, column) {
      // 性别
      if (column.property === "sexDesc") {
        return row.sex === 2 ? "女" : "男";
      }

      //其他
      else {
        return row[column.property];
      }
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        moduleId: this.moduleId,
        pageParamVo: { curPage: this.curPage, pageSize: this.pageSize }
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.getTableData(this.mergeObj());
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.getTableData(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.getTableData(this.mergeObj());
    },
    //打开编辑司机信息弹框
    handleDriverInfoEidtDialog(type, row) {
      if (type === "add") {
        this.driverInfoEditDialogName = "新增司机信息";
        this.driverInfoEditVisible = true;
      } else if (type === "edit") {
        this.driverInfoEditDialogName = "编辑司机信息";
        this.driverInfoEditVisible = true;
        this.$nextTick(() => {
          //数据回显
          this.showEditData(row);
        });
      }
    },
    //回显
    showEditData(row) {
      this.editForm = cloneDeep(row);
      //驾照类型未选择时，会返回0，做一下处理
      if (this.editForm.licenseLevel === 0) {
        this.editForm.licenseLevel = "";
      }
      //绑定车辆树的回显需要单独处理
      this.$nextTick(() => {
        this.$refs["t_select"].setSelectList([row.vehicleId]);
      });
    },
    //关闭dialog按钮
    closeEditDialog() {
      this.driverInfoEditVisible = false;
    },
    //保存dialog按钮
    submitEditDialog() {
      //校验
      try {
        this.$refs.editForm.validate(async flag => {
          if (flag) {
            try {
              this.saveDialog = true;
              //获得车辆选择树的结果
              let param = this.$refs["t_select"].getSelectValues();
              if (param.length > 0) {
                this.editForm.vehicleId = param[0].id;
                this.editForm.vehicleNo = param[0].label;
              }
              let res = await saveEditDriver(this.editForm);
              if (res.code === 1) {
                this.$message.success("保存成功");
                this.driverInfoEditVisible = false;
                this.handlesSubmitForm();
              } else if (res.code === 0) {
                this.$message.error(res.message);
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.saveDialog = false;
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 关闭dialog之后的回调
    handleCloseEditDialog() {
      this.$refs.editForm.resetFields();
      this.$refs["t_select"].multipleRemoveAll();
      this.editForm = cloneDeep(newEditForm);
    },
    //删除
    deleteDriverInfo(row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            let param = [];
            param.push(row);
            let res = await deleteDriver(param);
            if (res.code === 1) {
              this.$message.success("删除成功");
              this.handlesSubmitForm();
            } else {
              this.$message.error(res.message);
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //批量删除
    deleteBatchDriverInfo() {
      this.$confirm("确定要删除选中的司机信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            let res = await deleteDriver(this.multipleSelection);
            if (res.code === 1) {
              this.$message.success("删除成功");
              this.handlesSubmitForm();
            } else {
              this.$message.error(res.message);
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //导出
    handleExportClick() {
      let param = "";
      param += "&corpName=" + this.formExtend.forms.corpName;
      param += "&driverName=" + this.formExtend.forms.driverName;
      param += "&moduleId=" + this.moduleId;
      document.location.href = this.exportUrl + param;
    },
    /*------------------------------导入-----------------------------------*/
    openImport() {
      this.dialogImportVisible = true;
    },
    updateSuccess(val) {
      if (val) {
        this.dialogImportVisible = false;
        this.getTableData();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}

/deep/ .e6-from--column-2 .vehicle_temp {
  width: 100px !important;
}

/deep/ .el-dialog {
  .el-dialog__body {
    padding: 10px 20px;
    .vehicle_qrCode {
      text-align: center;
      .vehicle_info {
        margin: 10px;
        font-size: 16px;
      }
      #qrCode {
        display: flex;
        justify-content: center;
      }
    }
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-select--mini {
    width: 100%;
  }
}
</style>
